import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); clear(); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch { /* keep polling */ }
      if (attempts < 12) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-lg flex-col items-center justify-center px-5 text-center">
      {status === "checking" && (<>
        <Loader2 className="animate-spin text-secondary" size={48} />
        <h1 className="mt-6 font-display text-2xl font-800 text-white">Confirming your payment…</h1>
        <p className="mt-2 text-zinc-500">Hang tight, this only takes a moment.</p>
      </>)}
      {status === "paid" && (<>
        <CheckCircle2 className="text-emerald-400" size={56} data-testid="payment-success-icon" />
        <h1 className="mt-6 font-display text-3xl font-900 tracking-tight text-white">Order confirmed!</h1>
        <p className="mt-2 text-zinc-400">Thank you for your purchase. Your cards are being prepped for shipping.</p>
        <Link to="/catalog" className="mt-8 rounded-full bg-primary px-7 py-3.5 font-medium text-white transition-transform hover:-translate-y-1">Keep shopping</Link>
      </>)}
      {status === "failed" && (<>
        <XCircle className="text-red-400" size={56} />
        <h1 className="mt-6 font-display text-2xl font-800 text-white">Payment not confirmed</h1>
        <p className="mt-2 text-zinc-500">We couldn't verify your payment. If you were charged, contact support.</p>
        <button onClick={() => nav("/cart")} className="mt-8 rounded-full border border-white/15 px-7 py-3.5 font-medium text-white hover:bg-white/5">Back to cart</button>
      </>)}
    </div>
  );
}
